import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const ClientStatusFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}): JSX.Element => {
  const status = useAppSelector((state) => state.clients.status)

  const data = status.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Client Status'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
